import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';
import { TaskRequestsService } from '../task-requests.service';
import { ITaskRequest } from '../task-requests.interface';
import { IFilter } from '../../../../shared/interfaces/filter.interface';
import { Broadcaster } from '../../../../shared/components/broadcaster.component';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { UtilsService } from '../../../../shared/services/utils.service';
import { TaskModalComponent } from '../../../tasks-page/tasks/task-modal/task-modal.component';
import { IConfirmationDialogOptions } from '../../../../shared/services/dialog/confirmation-dialog/confirmation-dialog-options.interface';
import { IFile } from '../../../../shared/components/files/file.interface';
import { FileViewModalComponent } from '../../../../shared/components/file-view-modal/file-view-modal.component';
let self: any;

@Component({
  selector: 'app-task-requests-detail',
  templateUrl: './task-requests-detail.component.html',
  styleUrls: ['./task-requests-detail.component.css']
})
export class TaskRequestsDetailComponent implements OnInit {
  taskRequest!: ITaskRequest;
  loading: boolean = true;
  thereAreMore: boolean = false;
  filter: IFilter = {
    // filters: {
    //   isDeleted: false
    // },
    sort: '',
    skip: 0,
    limit: 20
  };
  filtered = false;
  totalMoreMinTutorial = false;
  scrollSubscription!: Subscription;
  querySubscription!: Subscription;
  selection: any = { all: false };
  isDev!: boolean;
  dialog: MatDialogRef<any>;

  constructor(
    private _TaskRequestsService: TaskRequestsService,
    private _broadcaster: Broadcaster,
    private _dialogService: DialogService,
    public dialogRef: MatDialogRef<any>,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private router: Router,
    private _route: ActivatedRoute,
    private _AuthService: AuthService,
    private _UtilService: UtilsService,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.getTaskRequest();
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    this.filtered = true;
    setTimeout(() => {
      console.log(tmp, this.lazySearchTmp);
      if (tmp == this.lazySearchTmp) {
        this.getTaskRequest();
      }
    }, 1000);
  }

  getTaskRequest() {
    this.loading = true;
    this._TaskRequestsService.getTaskRequest(this.taskRequest._id || '').subscribe((taskRequest: any) => {
      console.log(taskRequest)
      this.taskRequest = taskRequest
      this.loading = false;
    })
  }

  openTaskRequestClient() {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '1300px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskModalComponent, config);
    self.dialogRef.componentInstance.taskRequest = this.taskRequest;
    self.dialogRef.componentInstance.task = { status: 'SCHEDULED' };
    self.dialogRef.componentInstance.scheduling = true;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) this.dialog.close(result);
    });
  }

  openRejectedTaskRequestConfirm() {
    const clientName = this.taskRequest?.client?.firstname;
    const clientLastname = this.taskRequest?.client?.lastname ? ` ${this.taskRequest?.client?.lastname}` : '';
    const modalOptions: IConfirmationDialogOptions = {
      title: "Rechazar Solicitud",
      message: `¿Está seguro de que desea rechazar la solicitud de ${clientName}${clientLastname}?`,
      yesButtonLabel: 'Aceptar', noButtonLabel: 'Cancelar'
    };
    this._dialogService.openConfirmationModal(modalOptions, this._viewContainerRef)
      .subscribe((confirmation: any) => {
        if (confirmation) {
          this.loading = true;
          this._TaskRequestsService.updateTaskRequest({
            _id: _.get(this.taskRequest, 'taskRequest._id', this.taskRequest._id),
            company: this._AuthService.companyId(),
            status: 'REJECTED'
          }).subscribe(ok => {
            this.dialog.close(true);
          })
        }
      });
  }

  openFile(file: IFile) {
    if (!file._id) return;
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '700px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.fileDialogRef = this._dialog.open(FileViewModalComponent, config);
    self.fileDialogRef.componentInstance.file = file;

    self.fileDialogRef.afterClosed().subscribe((result: any) => {
      self.fileDialogRef = null;
    });
  }

  openPdf(file: IFile) {
    if (!file._id) return;
    window.open(file.fileUrl, "_blank");
  }
}